import React from "react";
import { useNavigate } from "react-router-dom";

export default function ResultCard({ res, onRevoke, revokeLoadingId }) {
    const navigate = useNavigate();

    if (!res) return null;

    return (
        <div className="mt-3 col-md-5">
            {/* EDIT / REVOKE BUTTON */}
            <div className="d-flex ac-je mb-2">
                {res.edit === true && (
                    <button
                        onClick={() =>
                            navigate("/announce-result-edit", {
                                state: { editData: res },
                            })
                        }
                        className="f3 fs-sm-8 fs-md-9 fs-lg-11 fs-xl-13 fs-xxl-15 edit1-btn"
                    >
                        Edit
                    </button>
                )}
                {res.edit === false && (
                    <button
                        onClick={() => onRevoke && onRevoke(res)}
                        disabled={revokeLoadingId === res.id}
                        className="f3 fs-sm-8 fs-md-9 fs-lg-11 fs-xl-13 fs-xxl-15 edit1-btn"
                    >
                        {revokeLoadingId === res.id ? "Revoking..." : "Revoke"}
                    </button>
                )}
            </div>

            {/* RESULT CARD */}
            <div
                style={{ backgroundColor: "#F0EDE6", borderRadius: 20 }}
                className="check_result border shadow-sm"
            >
                {/* DATE */}
                <div className="d-flex ac-jb my-2">
                    <h4 className="f3 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-16">Date</h4>
                    <p className="f2 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-16 gray">
                        {res.date}
                    </p>
                </div>

                {/* LOT NAME */}
                <div className="d-flex ac-jb my-2">
                    <p className="f3 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-16">
                        Lot Name
                    </p>
                    <p className="f2 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-16 gray">
                        {res.lot_name}
                    </p>
                </div>

                {/* TIME */}
                <div className="d-flex ac-jb my-2">
                    <p className="f3 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-16">Time</p>
                    <p className="f2 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-16 gray">
                        {res.time}
                    </p>
                </div>

                {/* RESULT NUMBER */}
                <div className="d-flex ac-jb my-2">
                    <p className="f3 fs-xs-16 fs-sm-16 fs-md-18 fs-lg-16">
                        Result Number
                    </p>

                    <div className="d-flex gap-2">
                        {String(res.winning_number)
                            .split("")
                            .map((num, i) => (
                                <input
                                    key={i}
                                    maxLength={1}
                                    type="text"
                                    readOnly
                                    value={num}
                                    className="result-input f3 text-center fs-xs-16 fs-sm-12 fs-md-14 fs-lg-14 fs-xl-15 fs-xxl-20 sec placholdercolorchanges2"
                                    style={{
                                        width: 28,
                                        height: 28,
                                        borderRadius: 30,
                                    }}
                                />
                            ))}
                    </div>
                </div>
            </div>
        </div>
    );
}